import React, { useState, useEffect } from 'react';
import './ProductListCompo.css';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import Modal from './Modal';
import { db } from '../lib/firebaseConfig';
import { collection, onSnapshot, deleteDoc, doc, setDoc, addDoc } from 'firebase/firestore';
import * as XLSX from 'xlsx';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import FileUploadIcon from '@mui/icons-material/FileUpload';

function ProductListCompo() {
  const [products, setProducts] = useState([]);
  const [editedProduct, setEditedProduct] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [importedProducts, setImportedProducts] = useState([]);

  useEffect(() => {
    const unsubscribe = onSnapshot(collection(db, 'ProductList'), (snapshot) => {
      const productsData = snapshot.docs.map((doc) => {
        return { id: doc.id, ...doc.data() };
      });
      setProducts(productsData);
    });

    return () => {
      unsubscribe();
    };
  }, []);

  useEffect(() => {
    // Récupérer les produits depuis server.js
    fetch('http://localhost:3001/products')
      .then((response) => response.json())
      .then((data) => {
        console.log('Products from server.js:', data);
      })
      .catch((error) => {
        console.error('Error fetching products from server.js:', error);
      });
  }, []);

  const handleDelete = async (productId) => {
    try {
      await deleteDoc(doc(db, 'ProductList', productId));
      console.log('Product deleted successfully from Firebase');
    } catch (error) {
      console.error('Error deleting product from Firebase:', error);
    }
  };

  const handleEdit = async (productId) => {
    try {
      const productToUpdate = products.find((product) => product.id === productId);
      await setDoc(doc(db, 'ProductList', productId), productToUpdate);
      console.log('Product updated successfully in Firebase');
      setEditedProduct(null);
    } catch (error) {
      console.error('Error updating product in Firebase:', error);
    }
  };

  const handleInputChange = (event, productId) => {
    const { name, value } = event.target;
    const updatedProducts = products.map((product) => {
      if (product.id === productId) {
        return { ...product, [name]: value };
      }
      return product;
    });
    setProducts(updatedProducts);
  };

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const excelData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

      // Map the Excel data to the required product format
      const products = excelData.slice(1).map((row) => ({
        name: row[0],
        price: row[1],
        pageUrl: row[2],
        details: row[3],
      }));

      setImportedProducts(products);

      // Add the imported products to Firebase
      products.forEach(async (product) => {
        try {
          await addDoc(collection(db, 'ProductList'), product);
          console.log('Product added successfully to Firebase');
        } catch (error) {
          console.error('Error adding product to Firebase:', error);
        }
      });
    };

    reader.readAsArrayBuffer(file);
  };

  const handleOpenFileInput = () => {
    const fileInput = document.getElementById("file-input");
    fileInput.click();
  };

  const handleDownloadTable = () => {
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(products);
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Products');
    XLSX.writeFile(workbook, 'product_table.xlsx');
  };

  return (
    <div className="ProductListCompo">

      <div style={{ margin: '20px', marginTop: '30px', position: 'absolute', bottom: '0.5%', right: '0', display: 'flex', flex: '1', flexDirection: 'row', gap: '10px'}}>
        <Modal isOpen={isModalOpen} onClose={handleCloseModal} />
        <label htmlFor="file-input">
          <input
            id="file-input"
            type="file"
            accept=".xlsx,.xls"
            onChange={handleFileUpload}
            style={{
              display: 'none',
            }}
          />
          <button
            style={{
              backgroundColor: 'blue',
              color: 'white',
              borderRadius: '100%',
              height: '50px',
              width: '50px',
              padding: '5px',
              paddingLeft: '20px',
              paddingRight: '20px',
              boxShadow: '0 0 10px 1px blue',
              border: 'none',
              cursor: 'pointer',
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              alignContent: 'center',
              justifyContent: 'center',
              gap: '5px'
            }}
            onClick={handleOpenFileInput}
          >
            <FileUploadIcon />
          </button>
        </label>
        
        {products.length > 0 && (
          <button
            style={{
              backgroundColor: 'blue',
              color: 'white',
              borderRadius: '100%',
              height: '50px',
              width: '50px',
              padding: '5px',
              paddingLeft: '20px',
              paddingRight: '20px',
              boxShadow: '0 0 10px 1px blue',
              border: 'none',
              cursor: 'pointer',
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              alignContent: 'center',
              justifyContent: 'center',
              gap: '5px'
            }}
            onClick={handleDownloadTable}
          >
            <FileDownloadIcon />
          </button>
        )}
      </div>

      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Price</th>
            <th>URL</th>
            <th>Details</th>
            <th>Delete</th>
            <th style={{ borderRight: 'none' }}>Edit</th>
          </tr>
        </thead>
        <tbody>
        {products.map((product) => (
          <tr key={product.id}>
            <td>
              {editedProduct?.id === product.id ? (
                <input
                  type="text"
                  name="name"
                  value={product.name}
                  onChange={(event) => handleInputChange(event, product.id)}
                />
              ) : (
                product.name
              )}
            </td>
            <td>
              {editedProduct?.id === product.id ? (
                <input
                  type="text"
                  name="price"
                  value={product.price}
                  onChange={(event) => handleInputChange(event, product.id)}
                />
              ) : (
                `$${Number(product.price).toFixed(2)}`
              )}
            </td>
            <td>
              {editedProduct?.id === product.id ? (
                <input
                  type="text"
                  name="pageUrl"
                  value={product.pageUrl}
                  onChange={(event) => handleInputChange(event, product.id)}
                />
              ) : (
                <a href={product.pageUrl} target="_blank" rel="noreferrer">
                  {product.pageUrl}
                </a>
              )}
            </td>
            <td>
              {editedProduct?.id === product.id ? (
                <input
                  type="text"
                  name="details"
                  value={product.details}
                  onChange={(event) => handleInputChange(event, product.id)}
                />
              ) : (
                product.details
              )}
            </td>
            <td>
              <button onClick={() => handleDelete(product.id)}>
                <DeleteIcon />
              </button>
            </td>
            <td style={{ borderRight: 'none' }}>
              {editedProduct?.id === product.id ? (
                <button onClick={() => handleEdit(product.id)}>
                  Save
                </button>
              ) : (
                <button onClick={() => setEditedProduct(product)}>
                  <EditIcon />
                </button>
              )}
            </td>
          </tr>
        ))}
        </tbody>
      </table>
    </div>
  );
}

export default ProductListCompo;
